import { isProduction } from "@/common/constants/env";

export const isOrgPageNewslettersEnabled = !isProduction;
